import React from "react";

import { ArrowForwardIos, PriorityHigh } from "@mui/icons-material";
import Close from "@mui/icons-material/Close";
import { Box, Button } from "@mui/material";

import { IconButton } from "@/components/Button";
import { Spacer } from "@/components/Spacer/Spacer";
import { HeadlineBold, Overline1 } from "@/components/Typography";
import { colors } from "@/theme/overrides/colors";

import { useBannerStyles } from "./base/styles";
import { BannerProps } from "./base/types";

export const UrgentBanner: React.FC<BannerProps> = ({
  title,
  message,
  buttonText,
  onClose,
  onClick,
}) => {
  const { classes } = useBannerStyles();

  return (
    <>
      <Box
        alignItems="center"
        bgcolor={colors.theme.danger.background}
        borderRadius="8px"
        display="flex"
        py="8px"
        pl="16px"
      >
        <Box
          alignItems="center"
          bgcolor={colors.theme.danger.light}
          borderRadius="50%"
          display="flex"
          justifyContent="center"
          height="48px"
          width="48px"
        >
          <PriorityHigh className={classes.colorWhite} />
        </Box>
        <Spacer w={16} />
        <Box flex={1}>
          <HeadlineBold text={title} />
          <Spacer h={4} />
          <Overline1 text={message} />
        </Box>
        <Button color="error" endIcon={<ArrowForwardIos />} onClick={onClick}>
          {buttonText}
        </Button>
        <Spacer w={16} />
        <Box className={classes.closeButtonPosition}>
          <IconButton icon={<Close />} size="smaller" onClick={onClose} />
        </Box>
      </Box>
    </>
  );
};
